<script lang="ts">
	// @ts-nocheck
	// Hand-built page for Legends of Tasmania, the signature Tassie Tours
	// offering. It deliberately sits outside the data-driven /tours/[tourName]
	// route (a static route wins over the dynamic one, so the tour keeps its
	// existing URL and every link to it still works) while continuing to use the
	// same Rezdy product and booking widget as every other tour.
	import { page } from '$app/stores';
	import Seo from '$lib/components/SEO.svelte';

	import Hero from '$lib/components/legends/Hero.svelte';
	import Intro from '$lib/components/legends/Intro.svelte';
	import Golf from '$lib/components/legends/Golf.svelte';
	import Trophy from '$lib/components/legends/Trophy.svelte';
	import Experience from '$lib/components/legends/Experience.svelte';
	import Gallery from '$lib/components/legends/Gallery.svelte';
	import Itinerary from '$lib/components/legends/Itinerary.svelte';
	import Booking from '$lib/components/legends/Booking.svelte';
	import Faq from '$lib/components/legends/Faq.svelte';
	import PrivateGolf from '$lib/components/legends/PrivateGolf.svelte';
	import Enquiry from '$lib/components/legends/Enquiry.svelte';
	import Cta from '$lib/components/legends/Cta.svelte';

	import { LEGENDS_PRICE, legendsItinerary } from '$lib/data/legends';

	const TOUR_NAME = 'Legends of Tasmania: Golf, History & Flavour – 4 Days, 4 Nights';
	const DESCRIPTION =
		'A premium 4-day, 4-night small-group golf journey through Tasmania. Play Lost Farm, Championship Golf Course, Launceston, Ratho Farm and 7 Mile Beach, with historic pubs, colonial villages, Cascade Brewery and premium accommodation along the way.';

	const touristTripSchema = $derived({
		'@context': 'https://schema.org',
		'@type': 'TouristTrip',
		name: TOUR_NAME,
		description: DESCRIPTION,
		duration: 'P4D',
		itinerary: {
			'@type': 'ItemList',
			numberOfItems: legendsItinerary.length,
			itemListElement: legendsItinerary.map((day, i) => ({
				'@type': 'ListItem',
				position: i + 1,
				name: day.heading
			}))
		},
		offers: {
			'@type': 'Offer',
			price: LEGENDS_PRICE.toFixed(2),
			priceCurrency: 'AUD',
			availability: 'https://schema.org/InStock',
			url: $page.url.href
		},
		provider: {
			'@type': 'TourOperator',
			name: 'Tassie Tours',
			url: $page.url.origin
		}
	});

	const breadcrumbSchema = $derived({
		'@context': 'https://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: [
			{ '@type': 'ListItem', position: 1, name: 'Home', item: $page.url.origin },
			{ '@type': 'ListItem', position: 2, name: 'Tours', item: `${$page.url.origin}/tours` },
			{ '@type': 'ListItem', position: 3, name: TOUR_NAME, item: $page.url.href }
		]
	});

	const schemaScript = $derived(
		`<script type="application/ld+json">${JSON.stringify(touristTripSchema)}${'<'}/script>` +
			`<script type="application/ld+json">${JSON.stringify(breadcrumbSchema)}${'<'}/script>`
	);
</script>

<svelte:head>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -- serialised JSON-LD built above -->
	{@html schemaScript}
</svelte:head>

<Seo
	title="Legends of Tasmania - 4 Day Golf, History & Flavour Tour - Tassie Tours"
	description={DESCRIPTION}
	keywords="Legends of Tasmania, Tasmania golf tour, 4 day golf tour Tasmania, Barnbougle Lost Farm tour, Ratho Farm golf, 7 Mile Beach golf, Championship Golf Course Launceston, small group golf tour Australia"
	siteName="Tassie Tours"
	imageURL="/images/hero-carousel-1.jpg"
	logo="/logo/logo-black.png"
	author="Tassie Tours"
	type="Tour"
	name="Tassie Tours"
	index={true}
	twitter={true}
	openGraph={true}
	schemaOrg={true}
	socials={[]}
/>

<Hero />
<Intro />
<Golf />
<Trophy />
<Experience />
<Gallery />
<Itinerary />
<Booking />
<Faq />
<PrivateGolf />
<Enquiry />
<Cta />
